import * as React from 'react';
import { colors } from '../../../index';

const IconPieChart = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 34 34",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.15 14.967H19.883a.853.853 0 01-.853-.854V.853c0-.471.381-.853.853-.853 7.785 0 14.114 6.328 14.114 14.113a.847.847 0 01-.847.854zM20.737 1.735v11.532h11.532C31.852 7.098 26.905 2.15 20.737 1.735z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.916 18.513c0 8.507-6.918 15.425-15.425 15.425C6.984 33.938.066 27.02.066 18.513c0-8.507 6.918-15.425 15.425-15.425.472 0 .853.381.853.853v13.725h13.718c.472 0 .854.382.854.847zm-15.425.853a.853.853 0 01-.854-.853V4.816c-7.174.437-12.871 6.418-12.871 13.697 0 7.57 6.155 13.725 13.725 13.725 7.286 0 13.26-5.704 13.697-12.872H15.491z"
  }));
};

export default IconPieChart;